module.exports = __webpack_public_path__ + "img/image1.34066e1f.png";